import { BaseValidator } from '../core/BaseValidator.js';
import { ValidationResult } from '../core/ValidationResult.js';
import { ChecksumCalculator } from '../utils/ChecksumCalculator.js';

/**
 * Taiwan ID validator following Single Responsibility Principle
 */
export class TwidValidator extends BaseValidator {
  constructor() {
    super({
      name: 'Taiwan Identity Card',
      pattern: /^[A-Z][12]\d{8}$/i,
      length: 10
    });
  }

  validateFormat(id) {
    const upperCaseId = id.toUpperCase();
    
    // Check length
    const lengthValidation = this.validateLength(upperCaseId, this.config.length);
    if (!lengthValidation.isValid) {
      return lengthValidation;
    }

    // Check pattern
    return this.validateRegex(
      upperCaseId,
      this.config.pattern,
      'TWID format must be a letter, followed by 1 or 2, then 8 digits'
    );
  }

  validateChecksum(id) {
    const upperCaseId = id.toUpperCase();
    const expectedChecksum = ChecksumCalculator.calculateTwidChecksum(upperCaseId);
    const actualChecksum = parseInt(upperCaseId.slice(-1));

    if (expectedChecksum !== actualChecksum) {
      return ValidationResult.invalid(
        `Invalid TWID checksum. Expected: ${expectedChecksum}, Got: ${actualChecksum}`
      );
    }

    return ValidationResult.valid('Valid TWID');
  }
}